import { IArticle } from '@models/IArticle';
import { IMeta } from '@models/IMeta';
import ArticleCard from '@molecules/ArticleCard/ArticleCard';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly sectionTitle?: string;
  readonly articles?: IArticle[];
  readonly meta: IMeta;
  readonly anchorId: string;
}

const RelatedArticles = ({
  sectionTitle,
  articles = [],
  meta,
  anchorId = '',
}: Props) =>
  !!articles.length && (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-epi-block-id={meta?.contentLink}
      id={`a-${anchorId}`}
      data-testid="CT-34-Related-Articles"
    >
      <NavigationCarousel
        id={`related-articles-carousel-${anchorId}`}
        shadows
        loop={false}
        items={articles}
        slidesToShowDesktop={3}
        slidesToShowTablet={2}
        slidesToShowMobile={1.3}
        spaceBetween={16}
        title={sectionTitle}
      >
        {(itemsToDisplay) =>
          itemsToDisplay.map((article, index) => (
            <SwiperSlide
              key={`Article-Card-${article.title}`}
              className="stretch-card"
            >
              <ArticleCard
                {...article}
                dataTestId={`CT-34-Related-Articles-Card-${index}`}
              />
            </SwiperSlide>
          ))
        }
      </NavigationCarousel>
    </section>
  );

export default RelatedArticles;
